import { CSSObject } from "@emotion/react";
import { Button, FloppyHollowSVG } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";

import { ASSIGNMENT_MODE } from "@/view/utils/currentAssignmentMode";
import { TAssignmentMode } from "@/view/utils/currentAssignmentMode/currentAssignmentMode";

const ButtonWithTrackEvent = withTrackEvent(Button);
interface PrimaryAction {
  assignmentMode?: TAssignmentMode;
  dataProps?: Record<string, string>;
  flavor?: string;
  label?: string;
  onClick: () => void;
  __cssFor?: CSSObject;
  icon?: {
    SvgComponent: typeof FloppyHollowSVG;
    alignment: string;
  };
}

export const BUTTON_VARIATIONS = {
  Create: {
    flavor: Button.flavors.primary,
    label: "Create assignment",
    dataQaSelector: "create-assignment-in-assignment-modal",
  },
  Update: {
    flavor: Button.flavors.primary,
    label: "Save changes",
    dataQaSelector: "update-assignment-in-assignment-modal",
  },
};

export const FooterActionButton = (props: PrimaryAction) => {
  const { assignmentMode, dataProps, flavor, icon, label, onClick, __cssFor } =
    props;

  type mode = keyof typeof BUTTON_VARIATIONS;

  const isCreateMode = assignmentMode === ASSIGNMENT_MODE.CREATE;

  const actionName = isCreateMode ? actionNames.create : actionNames.update;

  return (
    <ButtonWithTrackEvent
      flavor={flavor || BUTTON_VARIATIONS[assignmentMode as mode]?.flavor}
      objectType={objectTypes.assignment}
      actionName={actionName}
      onClick={onClick}
      dataProps={{
        "data-qa-selector":
          BUTTON_VARIATIONS[assignmentMode as mode]?.dataQaSelector,
        ...dataProps,
      }}
      /* @ts-expect-error */
      icon={icon}
      /* @ts-expect-error */
      __cssFor={__cssFor}
    >
      {label || BUTTON_VARIATIONS[assignmentMode as mode]?.label}
    </ButtonWithTrackEvent>
  );
};

export default FooterActionButton;
